export const common = {
  welcome: "Tere tulemast",
  login: "Logi sisse",
  logout: "Logi välja",
  signup: "Registreeru",
  appName: "Avatud Hoonete Platvorm",
  loading: "Laadimine...",
  error: "Viga",
  success: "Õnnestus",
  save: "Salvesta",
  saved: "Edukalt salvestatud",
  cancel: "Tühista",
  delete: "Kustuta",
  edit: "Muuda",
  create: "Loo",
  close: "Sulge",
  view: "Vaata",
  submit: "Esita",
  next: "Järgmine",
  previous: "Eelmine",
  back: "Tagasi",
  search: "Otsi",
  filter: "Filtreeri",
  sort: "Sorteeri",
  reset: "Lähtesta",
  select: "Vali",
  add: "Lisa",
  remove: "Eemalda",
  actions: "Tegevused",
  name: "Nimi",
  description: "Kirjeldus",
  date: "Kuupäev",
  status: "Olek",
  type: "Tüüp",
  category: "Kategooria",
  uploadingFile: "Faili üleslaadimine...",
  uploadSuccess: "Fail edukalt üles laaditud",
  uploadError: "Faili üleslaadimine ebaõnnestus",
  lastUpdated: "Viimati uuendatud",
  noData: "Andmeid pole",
  all: "Kõik",
  active: "Aktiivne",
  inactive: "Mitteaktiivne",
  viewMore: "Vaata rohkem",
  viewLess: "Vaata vähem",
  saveChanges: "Salvesta muudatused",
  discardChanges: "Loobu muudatustest",
  unsavedChangesPrompt: "Teil on salvestamata muudatusi. Kas soovite kindlasti lahkuda?",
  confirmDelete: "Kinnita kustutamine",
  confirmDeleteDescription:
    "Kas olete kindel, et soovite selle kustutada? Seda tegevust ei saa tagasi võtta.",
  yes: "Jah",
  no: "Ei",
  address: "Aadress",
  city: "Linn",
  country: "Riik",
  zipCode: "Postiindeks",
  phone: "Telefon",
  email: "E-post",
  website: "Veebileht",
  notAvailable: "Pole saadaval",
  darkMode: "Tume režiim",
  lightMode: "Hele režiim",
  info: "Informatsioon",
  warning: "Hoiatus",
  viewBuildings: "Vaata hooneid",
  semanticSearch: "Semantiline otsing",
  changeLanguage: "Vaheta keelt",
  logoutSuccess: "Edukalt välja logitud",
  logoutError: "Viga väljalogimisel",
  authRequired: "Autentimine vajalik",
  notFound: "Ei leitud",
  notFoundDescription: "Otsitavat lehte ei eksisteeri.",
  goHome: "Mine avalehele",
  pageNotFound: "Oih! Lehte ei leitud",
  returnHome: "Tagasi avalehele",
  continueEditing: "Jätka muutmist",
  saveAndExit: "Salvesta ja välju",
  totalResults: "Tulemusi kokku",
  settings: "Seaded",
  profile: "Profiil",
  allBuildings: "Kõik hooned",
  myAccount: "Minu konto",
  help: "Abi",
  support: "Tugi",
  contactUs: "Võta ühendust",
  about: "Meist",
  termsOfService: "Kasutustingimused",
  privacyPolicy: "Privaatsuspoliitika",
  version: "Versioon",
  uploadPhotos: "Lae üles fotosid",
  takePhoto: "Tee foto",
  shareLink: "Jaga linki",
  copyLink: "Kopeeri link",
  linkCopied: "Link kopeeritud lõikelauale",
  downloadPDF: "Laadi alla PDF",
  printDocument: "Prindi dokument",
  refreshData: "Värskenda andmeid",
  retry: "Proovi uuesti",
  accessDenied: "Juurdepääs keelatud",
  notAuthorized: "Pole volitatud",
  sessionExpired: "Sessioon aegus",
  pleaseReconnect: "Palun ühenduge uuesti",
  continue: "Jätka",
  expandAll: "Laienda kõik",
  collapseAll: "Ahenda kõik",
  showMore: "Näita rohkem",
  showLess: "Näita vähem",
  saving: "Salvestamine...",
  processing: "Töötlemine...",
  done: "Valmis",
  reports: "Aruanded",
  comingSoon: "Varsti tulemas",
  beta: "Beeta",
  notifications: "Teavitused",
  markAllAsRead: "Märgi kõik loetuks",
  clearAll: "Puhasta kõik",
  yesterday: "Eile",
  today: "Täna",
  tomorrow: "Homme",
  // Admin dashboard related translations
  adminDashboard: "Administraatori töölaud",
  users: "Kasutajad",
  userManagement: "Kasutajate haldus",
  registeredUsers: "Registreeritud kasutajad",
  manageUsers: "Halda kasutajaid",
  buildings: "Hooned",
  totalBuildings: "Hooneid kokku",
  documents: "Dokumendid",
  uploadedDocuments: "Üleslaaditud dokumendid",
  adminSettings: "Administraatori seaded",
  systemSettings: "Süsteemi seaded",
  noOrganizationSelected: "Organisatsioon pole valitud",
  settingsSaved: "Seaded edukalt salvestatud",
  errorSavingSettings: "Viga seadete salvestamisel",
  manageOrgSettings: "Halda organisatsiooni seadeid",
  organizationName: "Organisatsiooni nimi",
  saveSettings: "Salvesta seaded",
  userRoles: "Kasutajarollid",
  manageUserRoles: "Halda kasutajarolle",
  userRolesDescription: "Määra kasutajatele rollid oma organisatsioonis",
  allowUserInvites: "Luba kasutajate kutsumine",
  allowUserInvitesDescription: "Luba liikmetel kutsuda uusi kasutajaid",
  enforceEmailDomain: "Jõusta e-posti domeen",
  enforceEmailDomainDescription: "Luba registreeruda ainult kindlatel e-posti domeenidel",
  allowedDomains: "Lubatud domeenid",
  adminOnly: "Ainult administraator",
  general: "Üldine",
  security: "Turvalisus",
  generalSettings: "Üldised seaded",
  configureSystemSettings: "Seadista süsteemi sätteid",
  systemName: "Süsteemi nimi",
  publicRegistration: "Avalik registreerimine",
  allowNewUsers: "Luba uusi kasutajaid",
  maintenanceMode: "Hooldusrežiim",
  temporarilyDisableAccess: "Ajutiselt keela juurdepääs",
  logLevel: "Logi tase",
  securitySettings: "Turvalisuse seaded",
  configureSecuritySettings: "Seadista turvalisuse sätteid",
  enforceStrongPasswords: "Nõua tugevaid paroole",
  requireComplexPasswords: "Nõua keerukaid paroole",
  enableMFA: "Luba MFA",
  requireMFAForSecurity: "Nõua MFA turvalisuse jaoks",
  sessionTimeout: "Sessiooni aegumine",
  maxLoginAttempts: "Maksimaalsed sisselogimiskatsed",
  settingsReset: "Seadete lähtestamine",
  // Required props
  dashboard: "Töölaud",
  noOrganization: "Organisatsioon pole valitud",
  enterEmail: "Sisesta e-post",
  getAccess: "Taotle juurdepääsu",
  requestDemo: "Taotle demo",
  home: "Avaleht",
  personalSettings: "Isiklikud seaded",
  organizationSettings: "Halda organisatsiooni",
  switchedTo: "Vahetatud",
  selectOrganization: "Vali organisatsioon",
  noOrganizationsFound: "Organisatsioone ei leitud",
  refresh: "Värskenda",
  total: "Kokku",
  errorSavingChanges: "Viga muudatuste salvestamisel",
  loadingError: "Viga andmete laadimisel",
  invitations: "Kutsed",
  pendingInvitations: "Ootel kutsed organisatsioonidega liitumiseks",
  noPendingInvitations: "Ootavaid kutseid pole",
  pipelines: "Torujuhtmed",
  pipelinesComingSoon: "Torujuhtmete haldus tulemas varsti",
  pipelinesDescription: "Jälgi ja halda dokumentide töötlemise torujuhtmeid",
  pipelinesFeatures: {
    title: "Tulevased funktsioonid",
    monitoring: "Reaalajas torujuhtmete jälgimine",
    configuration: "Torujuhtmete konfiguratsiooni haldus",
    logs: "Üksikasjalikud töötlemise logid",
    metrics: "Jõudluse mõõdikud ja analüütika",
    alerts: "Torujuhtmete tõrgete hoiatused",
  },
  createNewOrganization: "Loo uus organisatsioon",
  userSettings: "Minu seaded",
  language: "Keel",
  organization: "Organisatsioon",
  organizationSelected: "Organisatsioon valitud",
  organizationSwitched: "Vahetatud organisatsioonile {name}.",
  invalidName: "Kehtetu nimi",
  organizationNameMinLength: "Organisatsiooni nimi peab olema vähemalt 2 tähemärki pikk.",
  userNotFound: "Kasutajat ei leitud. Palun logige uuesti sisse.",
  organizationCreatedSuccess: 'Organisatsioon "{name}" edukalt loodud.',
  createOrgDialogTitle: "Loo uus organisatsioon",
  createOrgDialogDescription: "Sisestage uue organisatsiooni nimi. Seda nime saab hiljem muuta.",
  organizationNameLabel: "Organisatsiooni nimi",
  organizationNamePlaceholder: "Sisesta organisatsiooni nimi",
  creating: "Loomine...",
  applicationError: "Rakenduse viga",
  unexpectedError: "Tekkis ootamatu viga.",
  reloadPage: "Laadi leht uuesti",
  tryAgain: "Proovi uuesti",
  retryAttempt: "Katse: {n}/3",
  sending: "Saatmine...",
  generating: "Genereerimine...",
  role: "Roll",
  somethingWentWrong: "Midagi l\u00E4ks valesti:",
  area: "Pindala...",
  units: "\u00DChikud",
  count: "Arv...",
  yearPlaceholder: "AAAA",
  seconds: "sekundit",
  complete: "Valmis",
  loadingOrgContext: "Organisatsiooni konteksti laadimine...",
  viewerDifferencesNotice:
    "Erinevused tuvastatakse automaatselt ja kõik muudatused ei pruugi olla kajastatud. Kontrolli tulemusi alati lähtefailide põhjal.",
  // Keep this approved accuracy copy in English until an Estonian version is supplied.
  viewerAccuracyNotice: {
    reference: {
      summary:
        "For reference viewing. Some file elements may not be fully represented. Use the original file for authoritative review.",
      title: "About file viewing",
      body: "Franklin provides a convenient view of DWG and IFC files. Some file elements, properties or references may not be fully represented in the viewer. For decisions requiring complete or authoritative file information, refer to the original source file.",
    },
    comparison: {
      summary:
        "Franklin helps identify differences between file versions. Automated comparison may not detect every change.",
      title: "About comparison accuracy",
      body: "Franklin is designed to assist with reviewing changes between file versions. Automated comparison results may be incomplete or inaccurate and may include missed or incorrectly identified changes. For critical design, engineering, construction or compliance decisions, the source files should be independently reviewed.",
    },
  },
  permissions: {
    denied: "Juurdep\u00E4\u00E4s keelatud",
    archiveBuildings: "Teil puudub \u00F5igus hooneid arhiveerida.",
    restoreBuildings: "Teil puudub \u00F5igus hooneid taastada.",
    createBuildings: "Teil puudub \u00F5igus hooneid luua.",
    editBuildings: "Teil puudub \u00F5igus hooneid muuta.",
    defaultMessage: "Teil puudub \u00F5igus selle toimingu tegemiseks.",
    projectAction: "Teil puudub \u00F5igus selles projektis {action}.",
    anyProjectAction: "Teil puudub \u00F5igus \u00FCheski oma projektis {action}.",
    ask: "Paluge kelleltki endale juurdep\u00E4\u00E4s.",
    noAccessTitle: "Teil puudub juurdep\u00E4\u00E4s",
    goToBuildings: "Mine hoonete juurde",
    actions: {
      manageIssues: "\u00FClesandeid luua ja muuta",
      addFiles: "faile \u00FCles laadida ja kaustu luua",
      deleteFiles: "faile j\u00E4\u00E4davalt kustutada",
      manageContacts: "kontakte lisada ja muuta",
      viewIssues: "\u00FClesandeid n\u00E4ha",
      useDrawingViewer: "joonisevaaturit kasutada",
      useModelViewer: "mudelivaaturit kasutada",
      viewContacts: "kontakte n\u00E4ha",
    },
  },
};
